import baseService from './baseService';

export const createPaymentMethod = () => baseService.post('/stripe/stripe_methods');

export const getCustomer = (id) => baseService.get(`/stripe/stripe_customers/${id}`);

export const updateCustomerPaymentMethod = (id, accountMethod, rewardMethod) =>
  baseService.patch(`/stripe/stripe_customers/${id}`, {
    account_payment_method: accountMethod,
    reward_payment_method: rewardMethod,
  });

export const createStripeUser = () => baseService.post('/stripe/stripe_users');

export const createBillingSession = () => baseService.get('/stripe/stripe_methods/0');

export const createDashboardSession = () => baseService.get('/stripe/stripe_users/-1');
